import { configureStore } from '@reduxjs/toolkit';
import dashboardSelectedAppReducer from './DashboardSelectedAppSlice.js';

const dashboardSelectedAppStore = configureStore({
  reducer: {
    dashboardSelectedApp: dashboardSelectedAppReducer,
  },
});

export default dashboardSelectedAppStore;